module.exports = __webpack_public_path__ + "static/media/transparent-plastic-bottles-filled-with-yellow-substance (4).a190359f.jpg";